@if (this.showDialog) {
  <dx-popup
    [maxWidth]="450"
    [height]="auto"
    [showCloseButton]="true"
    [showTitle]="true"
    title="{{ 'EDIT' | translate }}"
    [dragEnabled]="false"
    [closeOnOutsideClick]="false"
    [(visible)]="this.showDialog"
    class="popup-height-auto"
    animation="{ show:'duration:400'}">
    <div *dxTemplate="let data of 'content'">
      <div>
        <div>{{ 'DescriptionUa' | translate }}</div>
        <div>
          <dx-text-box [(value)]="this.category.descriptionUa"></dx-text-box>
        </div>
      </div>
      <div>
        <div>{{ 'DescriptionRu' | translate }}</div>
        <div>
          <dx-text-box [(value)]="this.category.descriptionRu"></dx-text-box>
        </div>
      </div>
      <div class="text-center">
        <dx-button class="btn me-2" icon="mdi mdi-content-save" text="{{ 'SAVE' | translate }}" (onClick)="this.onSave()"></dx-button>
        <dx-button class="btn btn-light ms-2" text="{{ 'CLOSE' | translate }}" (onClick)="this.onCancel()"></dx-button>
      </div>
    </div>
  </dx-popup>
}
